import React, { useEffect, useState } from 'react';
import './EditEmployeeModal.css';
import { Link } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import axios from 'axios';
import LoaderScreen from '../../components/LoaderScreen/LoaderScreen';
import { t } from '../../functions/genericFunctions';

import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { registerLocale, setDefaultLocale } from "react-datepicker";
import pt from 'date-fns/locale/pt';
registerLocale('pt', pt);

function EditEmployeeModal(props) {
    const inputProfilePhotoFileRef = React.useRef();
    const profilePhotoRef = React.useRef();

    const salaryInputRef = React.useRef();
    const phoneNumberInputRef = React.useRef();
    const emergencyPhoneNumberInputRef = React.useRef();
    const [salaryInputActiveFlag, setSalaryInputActiveFlag] = useState(false);
    const [phoneNumberInputActiveFlag, setPhoneNumberInputActiveFlag] = useState(false);
    const [emergencyPhoneNumberInputActiveFlag, setEmergencyPhoneNumberInputActiveFlag] = useState(false);
    const [dateOfBirthInput, setDateOfBirthInput] = useState(new Date());
    const [dateOfEmploymentInput, setDateOfEmploymentInput] = useState(new Date());

    const [cookie, setCookie] = useCookies();
    const [apiResponseText, setApiResponseText] = useState("");
    const [showLoaderScreenFlag, setShowLoaderScreenFlag] = useState(false);
    const [profilePhotoObj, setProfilePhotoObject] = useState(null);
    const [employeeFormData, setEmployeeFormData] = useState({
        'login_id': '',
        'password': '',
        'name': '',
        'rg_number': '',
        'cpf_number': '',
        'civil_status': 1,
        'address': '',
        'country_code': '+55',
        'phone_number': '',
        'emergency_contact_person': '',
        'emergency_contact_number': '',
        'number_of_children': '',
        'employment_date': '',
        'ct_number': '',
        'notes': '',
        'remote_employee': false,
        'shift_id': '',
        'contract_id': '-',
        'team_id': '',
        'position_id': '',
        'card_id': '',
        'image': null,
        'currency': 'BRL',
        'monthly_salary': '',
        'business_unit': '',
        'date_of_birth': '',
    });

    let employee_id = props.selectedEmployeeDetails['_id'];

    const [employeeUpdates, setEmployeeUpdates] = useState({});

    let allShiftsArr = props.allShifts;

    function updateEmployeeObj(key, value) {
        if (key === 'date_of_birth' || key === 'employment_date') {
            console.log(value);
            let dateValue = new Date(value);
            let yyyy = dateValue.getFullYear();
            let mm = dateValue.getMonth() + 1;
            let dd = dateValue.getDate();
            if (dd < 10) dd = '0' + dd;
            if (mm < 10) mm = '0' + mm;
            let formattedDate = yyyy + '-' + mm + '-' + dd;
            value = formattedDate;
            if (key === 'date_of_birth') {
                setDateOfBirthInput(dateValue);
            }
            else if (key === 'employment_date') {
                setDateOfEmploymentInput(dateValue);
            }
        }
        else if (key === "login_id") {
            return;
        }

        let employeeUpdatesTemp = JSON.parse(JSON.stringify(employeeUpdates));
        employeeUpdatesTemp[key] = value;
        if (key === "emergency_contact_number" || key === "phone_number") {
            employeeUpdatesTemp['country_code'] = employeeFormData['country_code'];
        }
        setEmployeeUpdates(JSON.parse(JSON.stringify(employeeUpdatesTemp)));
        updateEmployeeFormKey(key, value);
    }

    function updateEmployeeFormKey(key, value) {
        if (key === 'date_of_birth' || key === 'employment_date') {
            let dateValue = new Date(value);
            let yyyy = dateValue.getFullYear();
            let mm = dateValue.getMonth() + 1;
            let dd = dateValue.getDate();
            if (dd < 10) dd = '0' + dd;
            if (mm < 10) mm = '0' + mm;
            let formattedDate = yyyy + '-' + mm + '-' + dd;
            value = formattedDate;
        }
        let employeeFormTemp = JSON.parse(JSON.stringify(employeeFormData));
        employeeFormTemp[key] = value;
        setEmployeeFormData(JSON.parse(JSON.stringify(employeeFormTemp)));
    }

    function datePickerChange(value) {
        console.log(value);
    }

    function updateSalaryInput(input) {
        if (!input) {
            updateEmployeeObj('monthly_salary', "");
            return;
        }
        const regex = /([0-9]*[\.|\,]{0,1}[0-9]{0,2})/s;
        let match = input.match(regex);
        if (match) {
            let validSalaryInput = match[0];
            updateEmployeeObj('monthly_salary', validSalaryInput);
        }
    }
    function formatSalaryInput(input) {
        if (input === null || input === undefined || input === "") {
            return "";
        }
        try {
            var parts = input.toString().split(".");
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            return parts.join(".");
        } catch (e) {
            return "";
        }
    }

    function updatePhoneNumberInput(input) {
        if (input.length <= 11) {
            updateEmployeeObj('phone_number', input);
        }
    }

    function updateEmergencyPhoneNumberInput(input) {
        if (input.length <= 11) {
            console.log(input);
            updateEmployeeObj('emergency_contact_number', input);
        }
    }

    function formatPhoneNumberInput(input) {
        if (input === null || input === undefined) return "";
        try {
            input = input.toString();
            if (input.length > 0) {
                input = "(" + input;
                if (input.length > 2) {
                    input = input.slice(0, 3) + ") " + input.slice(3);
                }
                if (input.length > 9 && input.length <= 13) {
                    input = input.slice(0, 9) + " " + input.slice(9);
                }
                else if (input.length > 13) {
                    input = input.slice(0, 10) + " " + input.slice(10);
                }
                return input;
            }
        } catch (error) {
            console.log(error);
            return "";
        }
        return "";
    }

    function formatEmergencyPhoneNumberInput(input) {
        if (input === null || input === undefined) return "";
        try {
            input = input.toString();
            if (input.length > 0) {
                input = "(" + input;
                if (input.length > 2) {
                    input = input.slice(0, 3) + ") " + input.slice(3);
                }
                if (input.length > 9 && input.length <= 13) {
                    input = input.slice(0, 9) + " " + input.slice(9);
                }
                else if (input.length > 13) {
                    input = input.slice(0, 10) + " " + input.slice(10);
                }
                return input;
            }
        } catch (error) {
            return "";
        }
        return "";
    }

    function updateEmployeeSubmit() {
        let api_endpoint = process.env.REACT_APP_API_BASE_URL + "/employee/update/" + employee_id;
        setShowLoaderScreenFlag(true);
        let bodyFormData = new FormData();

        for (var key in employeeUpdates) {
            if (key === 'image') {

            }
            else {
                // Prevent sending "null" strings
                if (employeeUpdates[key] === null || employeeUpdates[key] === undefined) {
                    // Skip or send empty string depending on backend logic
                    bodyFormData.append(key, ""); 
                } else {
                    bodyFormData.append(key, employeeUpdates[key]);
                }
            }
        }

        if (profilePhotoObj != null) {
            bodyFormData.append('image', profilePhotoObj);
        }

        let options = { headers: { "Authorization": cookie['token'], "Content-Type": "multipart/form-data" } }

        axios
            .post(api_endpoint, bodyFormData, options)
            .then((response) => {
                setShowLoaderScreenFlag(false);
                let responseMsg = response.data.message;
                console.log(response.data);
                setApiResponseText(t("employee_updated_successfully!"));
                props.getAllEmployees();
                setTimeout(() => {
                    props.toggleEditEmployeeModal();
                }, 500);
            })
            .catch(error => {
                console.log(error.response.data);
                setShowLoaderScreenFlag(false);
                setApiResponseText(t("employee_could_not_be_updated,_check_entered_form_details_again!"));
            })
    }

    function onProfilePhotoChange(e) {
        // console.log(e.target.files);
        updateEmployeeFormKey('image', e.target.files[0]);
        let profilePhotoFileURL = URL.createObjectURL(e.target.files[0]);
        profilePhotoRef.current.src = profilePhotoFileURL;
        updateEmployeeObj('image', e.target.files[0]);
        setProfilePhotoObject(e.target.files[0]);
    }


    function formatDate(date) {
        if (!date) return ""; // Safety Check
        let value = new Date(date);
        let yyyy = value.getFullYear();
        let mm = value.getMonth() + 1;
        let dd = value.getDate();
        if (dd < 10) dd = '0' + dd;
        if (mm < 10) mm = '0' + mm;
        let formattedDate = yyyy + '-' + mm + '-' + dd;
        return formattedDate;
    }

    useEffect(() => {
        return () => {
        }
    }, [])


    useEffect(() => {
        if (!props.selectedEmployeeDetails) return;

        let details = props.selectedEmployeeDetails;
        let employeeFormDataTemp = {
            'employee_id': details['employee_id'] || "",
            'login_id': details['login_id'] || "",
            'password': "********",
            'name': details['name'] || "",
            'rg_number': details['rg_number'] || "",
            'cpf_number': details['cpf_number'] || "",
            'civil_status': details['civil_status'] !== undefined ? details['civil_status'] : 1,
            'address': details['address'] || "",
            
            // Nested Objects Safety
            'country_code': details['phone_number']?.['country_code'] || "+55",
            'phone_number': details['phone_number']?.['number'] || "",
            
            'emergency_contact_person': details['emergency_contact_person'] || "",
            
            // Nested Optional Object Safety
            'emergency_contact_number': details['emergency_contact_number']?.['number'] || "",
            
            'number_of_children': details['number_of_children'] || 0,
            'employment_date': formatDate(details['employment_date']),
            'ct_number': details['ct_number'] || "",
            'notes': details['notes'] || "",
            'remote_employee': details['remote_employee'] || false,
            'shift_id': details['shift_id'] || "",
            'contract_id': details['contract_id'] || "-",
            'team_id': details['team_id'] || "",
            'position_id': details['position_id'] || "",
            
            'card_id': details['card']?.['card_id'] || "",
            'image': "",
            
            // Nested Optional Object Safety
            'currency': details['monthly_salary']?.['currency'] || "BRL",
            'monthly_salary': details['monthly_salary']?.['salary'] || "",
            
            'business_unit': details['business_unit'] || "",
            'date_of_birth': formatDate(details['date_of_birth']),
        }
        setEmployeeFormData(JSON.parse(JSON.stringify(employeeFormDataTemp)));
        
        if (details['picture'] && details['picture'] != "") {
            profilePhotoRef.current.src = details['picture'];
        }

        // Set Date Pickers if dates exist
        if (details['date_of_birth']) setDateOfBirthInput(new Date(details['date_of_birth']));
        if (details['employment_date']) setDateOfEmploymentInput(new Date(details['employment_date']));

        return () => {

        }
    }, [props.selectedEmployeeDetails])


    return (
        <>
            <div id="EditEmployeeModal" className='modalContainer'>

                <div className='EditEmployeeCardContainer'>
                    <div className='container'>
                        <div className='row'>
                            <div className='col-12'>
                                <div className='cardContainer EditEmployeeModalArea'>
                                    <div className='closeModal' onClick={props.toggleEditEmployeeModal} >
                                        <img src="/icons/svg/close-1.svg" />
                                    </div>
                                    <div className='row employeeIdRow'>
                                        <div className='col-12'>
                                            <p>{t("employee_id")} - {employeeFormData['employee_id']}</p>
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-lg-3 col-md-3 col-sm-12 col-xs-12'>
                                            <div className='d-flex justify-content-center'>
                                                <div className="modalProfilePhotoContainer">
                                                    <div className='editProfilePhotoButton' onClick={() => { inputProfilePhotoFileRef.current.click() }}>
                                                        <img src="/icons/svg/Edit-Button.svg" />
                                                        <input hidden ref={inputProfilePhotoFileRef} type="file" accept=".png, .jpg, .jpeg" onChange={(e) => { onProfilePhotoChange(e) }} />
                                                    </div>
                                                    <div className='photoArea'>
                                                        <img ref={profilePhotoRef} src="/images/Profile-Photo.svg" />
                                                    </div>

                                                </div>
                                            </div>

                                        </div>

                                        <div className='col-lg-9 col-md-9 col-sm-12 col-xs-12'>
                                            <div className='inputFormContainer'>
                                                <div className='inputContainer EditEmployeeFormInputContainer'>
                                                    <h1>{t("full_name")}</h1>
                                                    <input type='text' value={employeeFormData['name']} onChange={(e) => updateEmployeeObj('name', e.target.value)} />
                                                </div>
                                                <div className='inputContainer EditEmployeeFormInputContainer'>
                                                    <h1>{t("business_unit")}</h1>
                                                    <input type='text' value={employeeFormData['business_unit']} onChange={(e) => updateEmployeeObj('business_unit', e.target.value)} />
                                                </div>
                                                <div className='inputContainer EditEmployeeFormInputContainer'>
                                                    <h1>{t("team")}</h1>
                                                    <input type='text' value={employeeFormData['team_id']} onChange={(e) => updateEmployeeObj('team_id', e.target.value)} />
                                                </div>
                                                <div className='inputContainer EditEmployeeFormInputContainer'>
                                                    <h1>{t("position")}</h1>
                                                    <input type='text' value={employeeFormData['position_id']} onChange={(e) => updateEmployeeObj('position_id', e.target.value)} />
                                                </div>
                                                <div className='row'>
                                                    <div className='col-lg-6 col-md-6 col-sm-6 col-xs-12'>
                                                        <div className='inputContainer EditEmployeeFormInputContainer'>
                                                            <h1>{t("date_of_birth")}</h1>
                                                            <DatePicker dateFormat="dd/MM/yyyy" locale="pt" onChange={(date) => updateEmployeeObj('date_of_birth', date)} selected={dateOfBirthInput} className="dateInput" wrapperClassName="dateInputWrapper" />
                                                        </div>
                                                    </div>
                                                    <div className='col-lg-6 col-md-6 col-sm-6 col-xs-12'>
                                                        <div className='inputContainer EditEmployeeFormInputContainer'>
                                                            <h1>{t("employment_date")}</h1>
                                                            <DatePicker dateFormat="dd/MM/yyyy" locale="pt" onChange={(date) => updateEmployeeObj('employment_date', date)} selected={dateOfEmploymentInput} className="dateInput" wrapperClassName="dateInputWrapper" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
                                            <div className='inputFormContainer'>
                                                <div className='inputContainer EditEmployeeFormInputContainer'>
                                                    <h1>{t("rg_number")}</h1>
                                                    <input type='text' value={employeeFormData['rg_number']} onChange={(e) => updateEmployeeObj('rg_number', e.target.value)} />
                                                </div>
                                                <div className='inputContainer EditEmployeeFormInputContainer'>
                                                    <h1>{t("cpf_number")}</h1>
                                                    <input type='text' value={employeeFormData['cpf_number']} onChange={(e) => updateEmployeeObj('cpf_number', e.target.value)} />
                                                </div>
                                                <div className='inputContainer EditEmployeeFormInputContainer'>
                                                    <h1>{t("civil_status")}</h1>
                                                    <select value={employeeFormData['civil_status']} onChange={(e) => updateEmployeeObj('civil_status', e.target.value)} >
                                                        <option value={1}>{t("married")}</option>
                                                        <option value={0}>{t("unmarried")}</option>
                                                    </select>
                                                </div>
                                                <div className='inputContainer EditEmployeeFormInputContainer'>
                                                    <h1>{t("number_of_children")}</h1>
                                                    <input type='text' value={employeeFormData['number_of_children']} onChange={(e) => updateEmployeeObj('number_of_children', e.target.value)} />
                                                </div>
                                                <div className='inputContainer EditEmployeeFormInputContainer'>
                                                    <h1>{t("ct_number")}</h1>
                                                    <input type='text' value={employeeFormData['ct_number']} onChange={(e) => updateEmployeeObj('ct_number', e.target.value)} />
                                                </div>
                                                <div className='inputContainer EditEmployeeFormInputContainer'>
                                                    <h1>{t("shift")}</h1>
                                                    <select value={employeeFormData['shift_id']} onChange={(e) => updateEmployeeObj('shift_id', e.target.value)} >
                                                        {
                                                            allShiftsArr.map((shift, index) => {
                                                                return <option key={index} value={shift['_id']}>{shift['name']}</option>
                                                            })
                                                        }
                                                    </select>
                                                </div>
                                                <div className='inputContainer EditEmployeeFormInputContainer'>
                                                    <h1>{t("login_id")}</h1>
                                                    <input type='text' value={employeeFormData['login_id']} onChange={(e) => updateEmployeeObj('login_id', e.target.value)} />
                                                </div>
                                                <div className='inputContainer EditEmployeeFormInputContainer'>
                                                    <h1>{t("remote_employee")}</h1>
                                                    <select value={employeeFormData['remote_employee']} onChange={(e) => updateEmployeeObj('remote_employee', e.target.value)} >
                                                        <option value={false}>{t("no")}</option>
                                                        <option value={true}>{t("yes")}</option>
                                                    </select>
                                                </div>
                                                <div className='inputContainer EditEmployeeFormInputContainer'>
                                                    <h1>{t("card_id")}</h1>
                                                    <input type='text' value={employeeFormData['card_id']} onChange={(e) => updateEmployeeObj('card_id', e.target.value)} />
                                                </div>
                                                <div className='inputContainer EditEmployeeFormInputContainer'>
                                                    <h1>{t("password")}</h1>
                                                    <input type='text' value={employeeFormData['password']} onChange={(e) => updateEmployeeObj('password', e.target.value)} placeholder='********' />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
                                            <div className='inputFormContainer'>
                                                <div className='inputContainer EditEmployeeFormInputContainer'>
                                                    <h1>{t("address")}</h1>
                                                    <textarea rows="4" value={employeeFormData['address']} onChange={(e) => updateEmployeeObj('address', e.target.value)} ></textarea>
                                                </div>
                                                <div className='inputContainer EditEmployeeFormInputContainer'>
                                                    <h1>{t("phone_number")}</h1>

                                                    <div className='salaryInputContainer'>
                                                        <input onClick={() => { phoneNumberInputRef.current.focus(); }} type='text' className={phoneNumberInputActiveFlag ? 'amountTextFocused amountText' : 'amountText'} value={formatPhoneNumberInput(employeeFormData['phone_number'])} onChange={(e) => { }} />
                                                        <input ref={phoneNumberInputRef} type="text" className='amountTextInput' value={employeeFormData['phone_number']} onChange={(e) => updatePhoneNumberInput(e.target.value)} onFocus={() => { setPhoneNumberInputActiveFlag(true) }} onBlur={() => { setPhoneNumberInputActiveFlag(false) }} />
                                                    </div>


                                                </div>
                                                <div className='inputContainer EditEmployeeFormInputContainer'>
                                                    <h1>{t("emergency_contact_name")}</h1>
                                                    <input type='text' value={employeeFormData['emergency_contact_person']} onChange={(e) => updateEmployeeObj('emergency_contact_person', e.target.value)} />
                                                </div>
                                                <div className='inputContainer EditEmployeeFormInputContainer'>
                                                    <h1>{t("emergency_contact_number")}</h1>

                                                    <div className='salaryInputContainer'>
                                                        <input onClick={() => { emergencyPhoneNumberInputRef.current.focus(); }} type='text' className={emergencyPhoneNumberInputActiveFlag ? 'amountTextFocused amountText' : 'amountText'} value={formatEmergencyPhoneNumberInput(employeeFormData['emergency_contact_number'])} onChange={(e) => { }} />
                                                        <input ref={emergencyPhoneNumberInputRef} type="text" className='amountTextInput' value={employeeFormData['emergency_contact_number']} onChange={(e) => updateEmergencyPhoneNumberInput(e.target.value)} onFocus={() => { setEmergencyPhoneNumberInputActiveFlag(true) }} onBlur={() => { setEmergencyPhoneNumberInputActiveFlag(false) }} />
                                                    </div>

                                                </div>
                                                <div className='inputContainer EditEmployeeFormInputContainer'>
                                                    <h1>{t("monthly_salary_(_brl_)")}</h1>
                                                    {/* <input type='text' value={employeeFormData['monthly_salary']} onChange={(e) => updateEmployeeObj('monthly_salary', e.target.value)} /> */}
                                                    <div className='salaryInputContainer'>
                                                        <input onClick={() => { salaryInputRef.current.focus(); }} type='text' className={salaryInputActiveFlag ? 'amountTextFocused amountText' : 'amountText'} value={formatSalaryInput(employeeFormData['monthly_salary'])} onChange={(e) => { }} />
                                                        <input ref={salaryInputRef} type="text" className='amountTextInput' value={employeeFormData['monthly_salary']} onChange={(e) => updateSalaryInput(e.target.value)} onFocus={() => { setSalaryInputActiveFlag(true) }} onBlur={() => { setSalaryInputActiveFlag(false) }} />
                                                    </div>
                                                </div>

                                                <div className='inputContainer EditEmployeeFormInputContainer'>
                                                    <h1>{t("notes")}</h1>
                                                    <textarea rows="8" value={employeeFormData['notes']} onChange={(e) => updateEmployeeObj('notes', e.target.value)}></textarea>
                                                </div>

                                            </div>
                                        </div>
                                        <div className='col-12'>
                                            <p className='apiResponseText'>{apiResponseText}</p>
                                            <div className='d-flex justify-content-end EditEmployeeFormActionContainer'>
                                                <button className='cancelButton' onClick={props.toggleEditEmployeeModal}>{t("cancel")}</button>
                                                <button className='saveButton' onClick={updateEmployeeSubmit}>{t("save")}</button>
                                            </div>
                                        </div>
                                    </div>
                                    <br />
                                </div>
                            </div>
                        </div>

                    </div>
                    <br /><br />
                </div>


            </div>
            <LoaderScreen showLoaderScreenFlag={showLoaderScreenFlag} />
        </>
    )
}

export default EditEmployeeModal;